module.exports = __webpack_public_path__ + "static/media/destination1.83f949c9.jpg";